import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { CloseJobAsCollaboratorDialogContainer } from '@/features/jobs/CloseJobAsCollaboratorDialog/CloseJobAsCollaboratorDialogContainer'
import { CreateJobDialogContainer } from '@/features/jobs/drafting/components/CreateJobDialog/CreateJobDialogContainer'
import { CouponModalContainer } from '@/features/jobs/drafting/components/JobCreation/Submission/CouponModal/CouponModalContainer'

export default observer(function Inner() {
  const { internal } = useFeatures(({ jobs }) => ({
    internal: jobs.internal(),
  }))

  return (
    <>
      <CloseJobAsCollaboratorDialogContainer
        vm={internal.jobRootViewModel.closeJobDialog}
      />
      <CreateJobDialogContainer vm={internal.jobCreationDialogViewModel} />
      <CouponModalContainer vm={internal.couponModalVm} />
    </>
  )
})
